import {CommonModule} from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {
    OrganizationCustomerIntegrationComponent,
} from '../edit-organization/organization-customer-integration/organization-customer-integration.component';
import {OrganizationDetailContext} from './organization-detail.context';

@Component({
    selector: 'app-organization-customer-integrations-page',
    standalone: true,
    imports: [CommonModule, OrganizationCustomerIntegrationComponent],
    template: `
        <section data-testid="organization-customer-integrations-page">
            <app-organization-customer-integration
                [organizationId]="organizationId"
                [organizationName]="organizationName"
                [hidePanelHeading]="true">
            </app-organization-customer-integration>
        </section>
    `,
})
export class OrganizationCustomerIntegrationsPageComponent implements OnInit, OnDestroy {
    organizationId: number | null = null;
    organizationName: string | null = null;
    private subs = new Subscription();

    constructor(
        private route: ActivatedRoute,
        private organizationContext: OrganizationDetailContext,
    ) {
    }

    ngOnInit(): void {
        this.subs.add(
            this.route.parent!.paramMap.subscribe((params) => {
                const raw = params.get('organizationId');
                const id = raw ? Number(raw) : NaN;
                this.organizationId = Number.isFinite(id) ? id : null;
            }),
        );
        this.subs.add(
            this.organizationContext.organization$.subscribe((org) => {
                this.organizationName = org?.name || null;
            }),
        );
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
